import React from "react";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <section id="about_us" className="about intro uk-margin-large-bottom">
      <div className="container--min uk-container uk-position-relative">
        <div className="uk-grid-collapse" data-uk-grid>
          <div className="intro__sidebar uk-width-1-4@m uk-visible@m uk-position-relative">
            <ul className="nav nav--intro uk-list js-scrollspy-nav">
              <li>
                <a href="#about_us">About us</a>
              </li>
              <li>
                <a href="#song-list">Song List</a>
              </li>
              <li className="hide">
                <a href="#music">Music</a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/@BackAlleyProphet"
                  target="_blank"
                >
                  Videos
                </a>
              </li>
              <li>
                <a href="#shows">Shows</a>
              </li>
              <li>
                <a href="#gallery">Gallery</a>
              </li>
              <li>
                <a href="#references">References</a>
              </li>
              <li>
                <a href="#contact">Contact</a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/groups/backalleyprophetband"
                  target="_blank"
                >
                  Facebook
                </a>
              </li>
            </ul>

            <div className="social__wrapper hide">
              <div className="social social--intro">
                <h6 className="uk-h4 social__title c-dark--4">Social media</h6>
                <ul className="social__list uk-list uk-align-center "></ul>
              </div>
            </div>
          </div>
          <div className="abt-mobile"></div>

          <div className="uk-width-3-4@m about__info">
            <h2 className="uk-text-right uk-h2">About🔮</h2>
            <div className="uk-text-right">
              <p>
                Back Alley Prophet, hailing from the Toronto and Durham areas, 
                electrifies audiences with their high-energy performances, blending 
                both original tracks and fresh takes on classic covers. With a 
                distinct 'Canadian Southern Rock' vibe, their sound is a unique 
                fusion of various genres, but the soul of Classic Rock and Blues 
                reigns supreme.
              </p>

              <div className="uk-text-right uk-margin-large-left">
                <p>
                  Lead vocalist{" "}
                  <a className="uk-text-warning" data-uk-toggle="target: #mary_crover">
                    Mary Crover
                  </a>{" "}
                  commands the stage with an unforgettable performance, unleashing 
                  her powerful vocals with every note. Sharing the spotlight and 
                  adding rich harmonies,{" "}
                  <a className="uk-text-warning" data-uk-toggle="target: #dennis_hebert">
                    Dennis Hebert
                  </a>{" "}
                  lead singer of 'Mustang', amplifies the band's sound, taking it 
                  to an entirely new level.

                </p>
              </div>

            </div>
            <div className="uk-text-right uk-margin-large-left">
              <p>
                The rhythm section, featuring{" "}
                <a className="uk-text-warning" data-uk-toggle="target: #dennis_hebert">
                  Dennis Hebert
                </a>{" "}
                on rhythm guitar,{" "}
                <a className="uk-text-warning" data-uk-toggle="target: #jeff_stones">
                  Jeff Stones
                </a>{" "}
                on bass, and{" "}
                <a className="uk-text-warning" data-uk-toggle="target: #ron_del">
                  Ron Del
                </a>{" "}
                on drums and percussion, locks into an unshakable groove, 
                providing a dynamic backbone for their diverse musical styles.
              </p>
            </div>

            <div className="uk-text-right uk-margin-large-left">
              <p>
                <a className="uk-text-warning" data-uk-toggle="target: #jake_lecuyer">
                  Jake LeCuyer
                </a>
                , the lead guitarist, elevates the band's energy with his soulful 
                and commanding guitar work, rounding out their explosive sound.
              </p>
            </div>

            <div className="uk-text-right uk-margin-large-left">
              <p>
                With a catalog of unique original songs that tell relatable stories, 
                Back Alley Prophet guarantees to get any crowd up on their feet—whether 
                it be dancing or simply soaking in the music.
              </p>
            </div>

            <div className="uk-text-right uk-margin-large-left">
              <p>
                Don't miss out on the next Back Alley Prophet performance—they're 
                ready to blow you away with their collection of songs and 
                unforgettable energy!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
